const imgUrl = 	'https://ruiba.oss-cn-beijing.aliyuncs.com';

export default imgUrl